/**
 * Embed mode detection.
 *
 * When the web app is loaded inside a native mobile WebView it receives
 * ?embed=true as a query parameter.  This module detects that flag
 * synchronously at module-load time (before any React effects run) and
 * persists the result to sessionStorage so the value survives in-app
 * navigation (e.g. /create → /room/:id) where the query string is gone.
 */

const _fromUrl = new URLSearchParams(window.location.search).get('embed') === 'true';
if (_fromUrl) {
  sessionStorage.setItem('embed', 'true');
  document.documentElement.setAttribute('data-embed', 'true');
}

export function isEmbedMode(): boolean {
  return sessionStorage.getItem('embed') === 'true';
}
